import { createLucideIcon } from "lucide-react"

/** Dooey mark as a Lucide-compatible icon */
export const DooeyIcon = createLucideIcon("DooeyIcon", [
  [
    "path",
    {
      key: "dooey-spark",
      d: "M9.6667 3.6667a3.3 3.3 0 1 1 4.6667 4.6667 3.3 3.3 0 0 1-4.6667-4.6667",
      fill: "currentColor",
      stroke: "none",
    },
  ],
  [
    "path",
    {
      key: "dooey-body",
      d: "M11.8293 13.2573 8.3333 9.7613a3.3 3.3 0 1 0-4.6667 4.6667l6 6a3.3 3.3 0 0 0 4.6667 0l6-6a3.3 3.3 0 1 0-4.6667-4.6667z",
      fill: "currentColor",
      stroke: "none",
      fillRule: "evenodd",
      clipRule: "evenodd",
    },
  ],
])

/** Outlined Dooey mark that matches Lucide's stroked icons */
export const DooeyOutlineIcon = createLucideIcon("DooeyOutlineIcon", [
  ["circle", { key: "dooey-spark", cx: "12", cy: "5.5", r: "2.5" }],
  [
    "path",
    {
      key: "dooey-body",
      d: "M12 15 7.25 10.25a2.475 2.475 0 1 0-3.5 3.5l6.5 6.5a2.475 2.475 0 0 0 3.5 0l6.5-6.5a2.475 2.475 0 1 0-3.5-3.5z",
    },
  ],
])
